<template>
  <footer id="footer">
    <div class="ft_utill">
      <div class="container">
        <ul class="ft_link">
          <li><a href="/page.do?site=10&id=149" title="새창열림">이용약관</a></li>
          <li>
            <a href="/page.do?site=10&id=153" title="새창열림"><strong>개인정보처리방침</strong></a>
          </li>
          <li>
            <a href="/page.do?site=10&id=269" title="새창열림"><strong>영상정보처리기기 운영·관리 방침</strong></a>
          </li>
          <li>
            <a href="/page.do?site=10&id=271" title="새창열림"><strong>정보주체 권리행사 절차</strong></a>
          </li>
          <li><a href="/page.do?site=10&id=152" title="새창열림">이메일무단수집거부</a></li>
          <li><a href="/page.do?site=10&id=45">오시는길</a></li>
        </ul>
        <ul class="ft_sns">
          <li>
            <a href="http://www.facebook.com/koreajobworld" target="_blank"><img src="@/assets/images/sns_icon_face.png" alt="한국잡월드 공식 페이스북" /></a>
          </li>
          <li>
            <a href="https://www.instagram.com/kjobworld/" target="_blank">
              <img src="@/assets/images/sns_icon_instar.png" alt="한국잡월드 공식 인스타그램" />
            </a>
          </li>
          <li>
            <a href="https://www.youtube.com/channel/UCD_0RYk-jy3PaE9mg6fGqsw/featured" target="_blank">
              <img src="@/assets/images/sns_icon_youtube.png" alt="한국잡월드 공식 유튜브" />
            </a>
          </li>
          <li>
            <a href="http://blog.naver.com/kjobworld" target="_blank"><img src="@/assets/images/sns_icon_blog.png" alt="한국잡월드 공식 블로그" /></a>
          </li>
          <li>
            <a href="http://pf.kakao.com/_zJxnuT" target="_blank"><img src="@/assets/images/sns_icon_kakao.png" alt="한국잡월드 공식 카카오" /></a>
          </li>
        </ul>
      </div>
    </div>
    <div class="ft_con">
      <div class="container">
        <ul class="address">
          <li>
            <span>경기도 성남시 분당구 분당수서로 501 (우)13553</span>
            &nbsp;
            <span>TEL:1644-1333</span>
            &nbsp;
            <span>FAX: (031)696-8421</span>
          </li>
          <li>
            <span class="name">상호명: 한국잡월드</span>
            &nbsp;
            <span>대표자: 이병균</span>
            &nbsp;
            <span>사업자등록번호:129-82-12308</span>
            &nbsp;
            <span>통신판매업신고번호 2012-경기성남-0645</span>
          </li>
          <li class="copyright">COPYRIGHT (C)KOREAJOBWORLD.OR.KR ALL RIGHTS RESERVED</li>
        </ul>
        <div class="cscenter">
          <dl>
            <dt>고객센터(운영시간 : 09시 ~ 18시)</dt>
            <dd>1644-1333</dd>
          </dl>
          <ul>
            <li>관람 운영시간 : 09시 ~ 18시30분</li>
            <li>매주 일요일, 1월1일, 명절 연휴 휴관</li>
            <li>숙련기술체험관 매주 토요일, 일요일 휴관</li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {};
</script>
